<template>
  <div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device Type:</span>
      <span class="text-sm">{{ systemInfo['Device Type'] || systemInfo.device_type || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">IP Address:</span>
      <span class="text-sm">{{ systemInfo['IP Address'] || systemInfo.ip_address || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">MAC Address:</span>
      <span class="text-sm">{{ systemInfo['MAC Address'] || systemInfo.mac_address || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Serial Number:</span>
      <span class="text-sm">{{ systemInfo['Serial No.'] || systemInfo['Serial No'] || systemInfo.serial_no || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Firmware Version:</span>
      <span class="text-sm">{{ systemInfo['Firmware Version'] || systemInfo.firmware_version || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">BIOS Version:</span>
      <span class="text-sm">{{ systemInfo['BIOS Version'] || systemInfo.bios_version || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">CPU Usage:</span>
      <span class="text-sm">{{ systemInfo['CPU Usage'] || systemInfo.cpu_usage || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Memory Usage:</span>
      <span class="text-sm">{{ systemInfo['Memory Usage'] || systemInfo.memory_usage || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Current Time:</span>
      <span class="text-sm">{{ systemInfo['Current Time'] || systemInfo.current_time || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Uptime:</span>
      <span class="text-sm">{{ systemInfo.Uptime || systemInfo.uptime || 'N/A' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BdcomSystemInfo',
  props: {
    systemInfo: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
}
</script>